import Component, { QUERY } from 'components/pages/Gaming/Gaming';
import { buildPage, buildQueryPreloader } from 'utils/pageHelper';

export default buildPage(Component, {
  metaData: {
    title: 'Gaming Offers',
    description:
      'Earn cashback on games and enjoy your wallet being a little bigger at the end of the month.',
  },
});
export const getStaticProps = buildQueryPreloader(QUERY);
